export type UserRole = 'none' | 'trainer' | 'coach' | 'subscriber' | 'admin';
export enum UserRoleEnum {
  NONE = 'none',
  SUBSCRIBER = 'subscriber',
  TRAINER = 'trainer',
  COACH = 'coach',
  ADMIN = 'admin'
}
